import { Formik, Form, Field } from "formik";
import { TextField, Button, MenuItem } from "@mui/material";
import * as yup from "yup";
import React, { Fragment, useState } from "react";
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '.././Helmet';
import RelatedLinks from "../RelatedLinks";
import { CalculatorsType } from "../ConstantsEN";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import sphereimg from "../../../images/ball.png";
import coneimg from "../../../images/cone.png";
import cube from "../../../images/cube.png";
import cylinderimg from "../../../images/cylinder.png";
import rectangularimg from "../../../images/prism.png";
import capsuleimg from "../../../images/capsule.png";
import conicalimg from "../../../images/conical-frustum.png";
import ellipsoidimg from "../../../images/ellipsoid.png";
import pyramidimg from "../../../images/square-pyramid.png";
import tubeimg from "../../../images/tube.png";
const TITLE = "Geometry Shapes Volume Calculator - Volume Calculator";
const DESCRIPTION = "This free calculator calculates volumes of common shapes including sphere, cone, cube, cylinder, capsule, cap, frustum cone, ellipsoid, pyramid, tube, and more.";
const KEYWORDS = "Volume Calculator, Sphere, Cone, Cube, Cylinder, Capsule, Cap, Frustum Cone, Ellipsoid, Pyramid, Tube, Shape Calculator, Volume Calculator, Free Calculator, Geometry Shapes, Shapes Volume Calculator, Sphere Volume Calculator, Cone Volume Calculator, Cube Volume Calculator, Cylinder Volume Calculator";
const OG_URL = "https://do-calculate.com/calculator/en/volumes";
const conversionMap = {
  centimeters: 0.01,
  inches: 0.0254,
  meters: 1,
  kilometers: 1000,
  feet: 0.3048,
  miles: 1609.34,
};
const sphereSchema = yup.object().shape({
  radius: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
});
const initialSphereValues = {
  radius: "",
  unit: "meters",
};
const coneSchema = yup.object().shape({
  baseRadius: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
  height: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
});
const initialConeValues = {
  baseRadius: "",
  height: "",
  baseRadiusUnit: "meters",
  heightUnit: "meters",
};
const cubeSchema = yup.object().shape({
  edge: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
});
const initialCubeValues = {
  edge: "",
  unit: "meters",
};
const cylinderSchema = yup.object().shape({
  baseRadius: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
  height: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
});
const initialCylinderValues = {
  baseRadius: "",
  height: "",
  baseRadiusUnit: "meters",
  heightUnit: "meters",
};
const rectangularSchema = yup.object().shape({
  length: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
  width: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
  height: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
});
const initialRectangularValues = {
  length: "",
  width: "",
  height: "",
  lengthUnit: "meters",
  widthUnit: "meters",
  heightUnit: "meters",
};
const capsuleSchema = yup.object().shape({
  baseRadius: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
  height: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
});
const initialCapsuleValues = {
  baseRadius: "",
  height: "",
  baseRadiusUnit: "meters",
  heightUnit: "meters",
};
const conicalSchema = yup.object().shape({
  topRadius: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
  bottomRadius: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
  height: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
});
const initialConicalValues = {
  topRadius: "",
  bottomRadius: "",
  height: "",
  topRadiusUnit: "meters",
  bottomRadiusUnit: "meters",
  heightUnit: "meters",
};
const ellipsoidSchema = yup.object().shape({
  axis1: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
  axis2: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
  axis3: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
});
const initialEllipsoidValues = {
  axis1: "",
  axis2: "",
  axis3: "",
  axis1Unit: "meters",
  axis2Unit: "meters",
  axis3Unit: "meters",
};
const pyramidSchema = yup.object().shape({
  baseEdge: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
  height: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
});
const initialPyramidValues = {
  baseEdge: "",
  height: "",
  baseEdgeUnit: "meters",
  heightUnit: "meters",
};
const tubeSchema = yup.object().shape({
  outerDiameter: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
  innerDiameter: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values")
    .when("outerDiameter", (outerDiameter, schema) => {
      return schema.test(
        "is-greater",
        "Inner diameter must be smaller than outer diameter",
        (innerDiameter) => outerDiameter > innerDiameter
      );
    }),
  length: yup
    .number()
    .typeError("Make sure the value is a number")
    .required("Make sure to enter a value")
    .max(1000000000, "Number is too large")
    .min(0, "Make sure not to enter negative values"),
});
const initialTubeValues = {
  outerDiameter: "",
  innerDiameter: "",
  length: "",
  outerDiameterUnit: "meters",
  innerDiameterUnit: "meters",
  lengthUnit: "meters",
};
const VolumesCalculator = () => {
  const [sphereVolume, setSphereVolume] = useState("");
  const [convertedSphereUnit, setConvertedSphereUnit] = useState("meters");
  const onSubmitSphere = (values) => {
    const { radius, unit } = values;
    const sphereVolume = (4 / 3) * Math.PI * Math.pow(radius, 3);
    setSphereVolume(sphereVolume);
    setConvertedSphereUnit(unit);
  };
  const [coneVolume, setConeVolume] = useState("");
  const [convertedConeUnit, setConvertedConeUnit] = useState("meters");
  const onSubmitCone = (values) => {
    const { baseRadius, height, baseRadiusUnit, heightUnit } = values;
    let convertedBaseRadius = baseRadius;
    let convertedHeight = height;
    if (baseRadiusUnit !== heightUnit) {
      if (conversionMap[baseRadiusUnit] < conversionMap[heightUnit]) {
        convertedBaseRadius =
          (baseRadius * conversionMap[baseRadiusUnit]) /
          conversionMap[heightUnit];
        setConvertedConeUnit(heightUnit);
      } else {
        convertedHeight =
          (height * conversionMap[heightUnit]) / conversionMap[baseRadiusUnit];
        setConvertedConeUnit(baseRadiusUnit);
      }
    } else {
      setConvertedConeUnit(baseRadiusUnit);
    }
    const coneVolume =
      (1 / 3) * Math.PI * Math.pow(convertedBaseRadius, 2) * convertedHeight;
    setConeVolume(coneVolume);
  };
  const [cubeVolume, setCubeVolume] = useState("");
  const [convertedCubeUnit, setConvertedCubeUnit] = useState("meters");
  const onSubmitCube = (values) => {
    const { edge, unit } = values;
    const cubeVolume = Math.pow(edge, 3);
    setCubeVolume(cubeVolume);
    setConvertedCubeUnit(unit);
  };
  const [cylinderVolume, setCylinderVolume] = useState("");
  const [convertedCylinderUnit, setConvertedCylinderUnit] = useState("meters");
  const onSubmitCylinder = (values) => {
    const { baseRadius, height, baseRadiusUnit, heightUnit } = values;
    let convertedBaseRadius = baseRadius;
    let convertedHeight = height;
    if (baseRadiusUnit !== heightUnit) {
      if (conversionMap[baseRadiusUnit] < conversionMap[heightUnit]) {
        convertedBaseRadius =
          (baseRadius * conversionMap[baseRadiusUnit]) /
          conversionMap[heightUnit];
        setConvertedCylinderUnit(heightUnit);
      } else {
        convertedHeight =
          (height * conversionMap[heightUnit]) / conversionMap[baseRadiusUnit];
        setConvertedCylinderUnit(baseRadiusUnit);
      }
    } else {
      setConvertedCylinderUnit(baseRadiusUnit);
    }
    const cylinderVolume =
      Math.PI * Math.pow(convertedBaseRadius, 2) * convertedHeight;
    setCylinderVolume(cylinderVolume);
  };
  const [rectangularVolume, setRectangularVolume] = useState("");
  const [convertedRectangularUnit, setConvertedRectangularUnit] =
    useState("meters");
  const onSubmitRectangular = (values) => {
    const { length, width, height, lengthUnit, widthUnit, heightUnit } = values;
    let convertedLength = length;
    let convertedWidth = width;
    let convertedHeight = height;
    let resultUnit = "";
    if (
      conversionMap[lengthUnit] >= conversionMap[widthUnit] &&
      conversionMap[lengthUnit] >= conversionMap[heightUnit]
    ) {
      resultUnit = lengthUnit;
    } else if (
      conversionMap[widthUnit] >= conversionMap[lengthUnit] &&
      conversionMap[widthUnit] >= conversionMap[heightUnit]
    ) {
      resultUnit = widthUnit;
    } else {
      resultUnit = heightUnit;
    }
    if (resultUnit !== lengthUnit) {
      convertedLength =
        (length * conversionMap[lengthUnit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== widthUnit) {
      convertedWidth =
        (width * conversionMap[widthUnit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== heightUnit) {
      convertedHeight =
        (height * conversionMap[heightUnit]) / conversionMap[resultUnit];
    }
    const rectangularVolume =
      convertedLength * convertedWidth * convertedHeight;
    setRectangularVolume(rectangularVolume);
    setConvertedRectangularUnit(resultUnit);
  };
  const [capsuleVolume, setCapsuleVolume] = useState("");
  const [convertedCapsuleUnit, setConvertedCapsuleUnit] = useState("meters");
  const onSubmitCapsule = (values) => {
    const { baseRadius, height, baseRadiusUnit, heightUnit } = values;
    let convertedBaseRadius = baseRadius;
    let convertedHeight = height;
    let resultUnit = "";
    if (conversionMap[baseRadiusUnit] >= conversionMap[heightUnit]) {
      resultUnit = baseRadiusUnit;
    } else {
      resultUnit = heightUnit;
    }
    if (resultUnit !== baseRadiusUnit) {
      convertedBaseRadius =
        (baseRadius * conversionMap[baseRadiusUnit]) /
        conversionMap[resultUnit];
    }
    if (resultUnit !== heightUnit) {
      convertedHeight =
        (height * conversionMap[heightUnit]) / conversionMap[resultUnit];
    }
    const capsuleVolume =
      (4 / 3) * Math.PI * Math.pow(convertedBaseRadius, 3) +
      Math.PI * Math.pow(convertedBaseRadius, 2) * convertedHeight;
    setCapsuleVolume(capsuleVolume);
    setConvertedCapsuleUnit(resultUnit);
  };
  const [conicalVolume, setConicalVolume] = useState("");
  const [convertedConicalUnit, setConvertedConicalUnit] = useState("meters");
  const onSubmitConical = (values) => {
    const {
      topRadius,
      bottomRadius,
      height,
      topRadiusUnit,
      bottomRadiusUnit,
      heightUnit,
    } = values;
    let convertedTopRadius = topRadius;
    let convertedBottomRadius = bottomRadius;
    let convertedHeight = height;
    let resultUnit = "";
    if (
      conversionMap[topRadiusUnit] >= conversionMap[bottomRadiusUnit] &&
      conversionMap[topRadiusUnit] >= conversionMap[heightUnit]
    ) {
      resultUnit = topRadiusUnit;
    } else if (
      conversionMap[bottomRadiusUnit] >= conversionMap[topRadiusUnit] &&
      conversionMap[bottomRadiusUnit] >= conversionMap[heightUnit]
    ) {
      resultUnit = bottomRadiusUnit;
    } else {
      resultUnit = heightUnit;
    }
    if (resultUnit !== topRadiusUnit) {
      convertedTopRadius =
        (topRadius * conversionMap[topRadiusUnit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== bottomRadiusUnit) {
      convertedBottomRadius =
        (bottomRadius * conversionMap[bottomRadiusUnit]) /
        conversionMap[resultUnit];
    }
    if (resultUnit !== heightUnit) {
      convertedHeight =
        (height * conversionMap[heightUnit]) / conversionMap[resultUnit];
    }
    const conicalVolume =
      (1 / 3) *
      Math.PI *
      convertedHeight *
      (Math.pow(convertedTopRadius, 2) +
        Math.pow(convertedBottomRadius, 2) +
        convertedTopRadius * convertedBottomRadius);
    setConicalVolume(conicalVolume);
    setConvertedConicalUnit(resultUnit);
  };
  const [ellipsoidVolume, setEllipsoidVolume] = useState("");
  const [convertedEllipsoidUnit, setConvertedEllipsoidUnit] =
    useState("meters");
  const onSubmitEllipsoid = (values) => {
    const { axis1, axis2, axis3, axis1Unit, axis2Unit, axis3Unit } = values;
    let convertedAxis1 = axis1;
    let convertedAxis2 = axis2;
    let convertedAxis3 = axis3;
    let resultUnit = "";
    if (
      conversionMap[axis1Unit] >= conversionMap[axis2Unit] &&
      conversionMap[axis1Unit] >= conversionMap[axis3Unit]
    ) {
      resultUnit = axis1Unit;
    } else if (
      conversionMap[axis2Unit] >= conversionMap[axis1Unit] &&
      conversionMap[axis2Unit] >= conversionMap[axis3Unit]
    ) {
      resultUnit = axis2Unit;
    } else {
      resultUnit = axis3Unit;
    }
    if (resultUnit !== axis1Unit) {
      convertedAxis1 =
        (axis1 * conversionMap[axis1Unit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== axis2Unit) {
      convertedAxis2 =
        (axis2 * conversionMap[axis2Unit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== axis3Unit) {
      convertedAxis3 =
        (axis3 * conversionMap[axis3Unit]) / conversionMap[resultUnit];
    }
    const ellipsoidVolume =
      (4 / 3) * Math.PI * convertedAxis1 * convertedAxis2 * convertedAxis3;
    setEllipsoidVolume(ellipsoidVolume);
    setConvertedEllipsoidUnit(resultUnit);
  };
  const [pyramidVolume, setPyramidVolume] = useState("");
  const [convertedPyramidUnit, setConvertedPyramidUnit] = useState("meters");
  const onSubmitPyramid = (values) => {
    const { baseEdge, height, baseEdgeUnit, heightUnit } = values;
    let convertedBaseEdge = baseEdge;
    let convertedHeight = height;
    let resultUnit = "";
    if (conversionMap[baseEdgeUnit] >= conversionMap[heightUnit]) {
      resultUnit = baseEdgeUnit;
    } else {
      resultUnit = heightUnit;
    }
    if (resultUnit !== baseEdgeUnit) {
      convertedBaseEdge =
        (baseEdge * conversionMap[baseEdgeUnit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== heightUnit) {
      convertedHeight =
        (height * conversionMap[heightUnit]) / conversionMap[resultUnit];
    }
    const pyramidVolume =
      (1 / 3) * Math.pow(convertedBaseEdge, 2) * convertedHeight;
    setPyramidVolume(pyramidVolume);
    setConvertedPyramidUnit(resultUnit);
  };
  const [tubeVolume, setTubeVolume] = useState("");
  const [convertedTubeUnit, setConvertedTubeUnit] = useState("meters");
  const [errorDiameter, setErrorDiameter] = useState("");
  const onSubmitTube = (values) => {
    const {
      outerDiameter,
      innerDiameter,
      length,
      outerDiameterUnit,
      innerDiameterUnit,
      lengthUnit,
    } = values;
    let convertedOuterDiameter = outerDiameter;
    let convertedInnerDiameter = innerDiameter;
    let convertedLength = length;
    let resultUnit = "";
    if (
      conversionMap[outerDiameterUnit] >= conversionMap[innerDiameterUnit] &&
      conversionMap[outerDiameterUnit] >= conversionMap[lengthUnit]
    ) {
      resultUnit = outerDiameterUnit;
    } else if (
      conversionMap[innerDiameterUnit] >= conversionMap[outerDiameterUnit] &&
      conversionMap[innerDiameterUnit] >= conversionMap[lengthUnit]
    ) {
      resultUnit = innerDiameterUnit;
    } else {
      resultUnit = lengthUnit;
    }
    if (resultUnit !== outerDiameterUnit) {
      convertedOuterDiameter =
        (outerDiameter * conversionMap[outerDiameterUnit]) /
        conversionMap[resultUnit];
    }
    if (resultUnit !== innerDiameterUnit) {
      convertedInnerDiameter =
        (innerDiameter * conversionMap[innerDiameterUnit]) /
        conversionMap[resultUnit];
    }
    if (resultUnit !== lengthUnit) {
      convertedLength =
        (length * conversionMap[lengthUnit]) / conversionMap[resultUnit];
    }
    if (convertedOuterDiameter < convertedInnerDiameter) {
      setErrorDiameter(
        "Please ensure that the inner diameter value is smaller than the outer diameter value"
      );
    } else {
      setErrorDiameter("");
    }
    const tubeVolume = (
      Math.PI *
      ((Math.pow(convertedOuterDiameter, 2) -
        Math.pow(convertedInnerDiameter, 2)) /
        4) *
      convertedLength
    ).toFixed(2);
    setTubeVolume(tubeVolume);
    setConvertedTubeUnit(resultUnit);
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="row">
  <div>
    <p>
      The geometric shapes volume calculator calculates volumes of common shapes including sphere, cone, cube, cylinder, capsule, frustum, ellipsoid, pyramid, tube, and more.
    </p>
    <h2 style={{ fontSize: "17px" }}>
      Volumes of geometric shapes are calculated as follows:
    </h2>
    <ul>
      <li>
        Volume of a spherical body: (4/3) × π × radius cubed
      </li>
      <li>
        Volume of a cone: (1/3) × π × radius squared × height
      </li>
      <li>Volume of a cube: side length cubed</li>
      <li>
        Volume of a cylinder: π × radius squared × height
      </li>
      <li>Volume of a rectangular tank: length × width × height</li>
      <li>
        Volume of a capsule: (4/3) × π × major radius cubed + π × major radius squared × height
      </li>
      <li>
        Volume of a frustum: (1/3) × π × height × (upper base radius squared + (upper base radius × lower base radius) + lower base radius squared)
      </li>
      <li>Volume of an ellipsoid: (4/3) × π × a × b × c</li>
      <li>
        Volume of a pyramid: (1/3) × base area squared × height
      </li>
      <li>
        Volume of a tube: π × (outer tube diameter squared - inner tube diameter squared) / 4 × 4
      </li>
    </ul>
    <b>
      You can also use the following calculator to find volumes of geometric shapes:
    </b>
    <hr />
  </div>
</div>
 <MobileUnderCalAds/>
<div className="row">
  <div className="col-sm-12 col-md-7 calculatorStyle">
    <Formik
      initialValues={initialSphereValues}
      validationSchema={sphereSchema}
      onSubmit={onSubmitSphere}
    >
      {(formik) => (
        <Form>
          <div className="mb-3">
            <h3
              className="p-3 mb-2 bg-success text-white"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              Sphere Volume Calculation - Sphere Volume Calculator
            </h3>
            <TextField
              label="Radius"
              name="radius"
              value={formik.values.radius}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.radius && formik.errors.radius}
              helperText={
                formik.touched.radius && formik.errors.radius
              }
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="unit"
              value={formik.values.unit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <Button
              type="submit"
              disabled={!formik.isValid}
              color="success"
              sx={{
                backgroundColor: "rgb(25,135,84)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
            >
              Calculate
            </Button>
            <Button
              disabled={!formik.isValid}
              sx={{
                backgroundColor: "rgb(108,117,125)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
              onClick={() => {
                setSphereVolume(null);
                formik.resetForm();
              }}
            >
              Clear Result
            </Button>
          </div>
          {sphereVolume && sphereVolume > 0 ? (
            <Fragment>
              <p className="p-3 mb-2 bg-success text-white">
                Result: The volume of the sphere is: {sphereVolume}{" "}
                {convertedSphereUnit}
                <sup>3</sup>
              </p>
            </Fragment>
          ) : (
            ""
          )}
        </Form>
      )}
    </Formik>
  </div>
  <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
    <img alt="Sphere Volume Calculation" src={sphereimg} />
  </div>
</div>
<hr />
<div className="row">
  <div className="col-sm-12 col-md-7 calculatorStyle">
    <Formik
      initialValues={initialConeValues}
      validationSchema={coneSchema}
      onSubmit={onSubmitCone}
    >
      {(formik) => (
        <Form>
          <div className="mb-3">
            <h3
              className="p-3 mb-2 bg-success text-white"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              Cone Volume Calculation - Cone Volume Calculator
            </h3>
            <TextField
              label="Base Radius"
              name="baseRadius"
              value={formik.values.baseRadius}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.baseRadius && formik.errors.baseRadius
              }
              helperText={
                formik.touched.baseRadius && formik.errors.baseRadius
              }
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="baseRadiusUnit"
              value={formik.values.baseRadiusUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <TextField
              label="Height"
              name="height"
              value={formik.values.height}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.height && formik.errors.height}
              helperText={
                formik.touched.height && formik.errors.height
              }
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="heightUnit"
              value={formik.values.heightUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <Button
              type="submit"
              disabled={!formik.isValid}
              color="success"
              sx={{
                backgroundColor: "rgb(25,135,84)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
            >
              Calculate
            </Button>
            <Button
              disabled={!formik.isValid}
              sx={{
                backgroundColor: "rgb(108,117,125)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
              onClick={() => {
                setConeVolume(null);
                formik.resetForm();
              }}
            >
              Clear Result
            </Button>
          </div>
          {coneVolume && coneVolume > 0 ? (
            <Fragment>
              <p className="p-3 mb-2 bg-success text-white">
                Result: The volume of the cone is: {coneVolume}{" "}
                {convertedConeUnit}
                <sup>3</sup>
              </p>
            </Fragment>
          ) : (
            ""
          )}
        </Form>
      )}
    </Formik>
  </div>
  <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
    <img alt="Cone Volume Calculation" src={coneimg} />
  </div>
</div>
<hr />
<div className="row">
  <div className="col-sm-12 col-md-7 calculatorStyle">
    <Formik
      initialValues={initialCubeValues}
      validationSchema={cubeSchema}
      onSubmit={onSubmitCube}
    >
      {(formik) => (
        <Form>
          <div className="mb-3">
            <h3
              className="p-3 mb-2 bg-success text-white"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              Cube Volume Calculation - Cube Volume Calculator
            </h3>
            <TextField
              label="Edge Length"
              name="edge"
              value={formik.values.edge}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.edge && formik.errors.edge}
              helperText={formik.touched.edge && formik.errors.edge}
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="unit"
              value={formik.values.unit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <Button
              type="submit"
              disabled={!formik.isValid}
              color="success"
              sx={{
                backgroundColor: "rgb(25,135,84)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
            >
              Calculate
            </Button>
            <Button
              disabled={!formik.isValid}
              sx={{
                backgroundColor: "rgb(108,117,125)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
              onClick={() => {
                setCubeVolume(null);
                formik.resetForm();
              }}
            >
              Clear Result
            </Button>
          </div>
          {cubeVolume && cubeVolume > 0 ? (
            <Fragment>
              <p className="p-3 mb-2 bg-success text-white">
                Result: The volume of the cube is: {cubeVolume}{" "}
                {convertedCubeUnit}
                <sup>3</sup>
              </p>
            </Fragment>
          ) : (
            ""
          )}
        </Form>
      )}
    </Formik>
  </div>
  <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
    <img alt="Cube Volume Calculation" src={cube} />
  </div>
</div>
<hr />
                    <div className="row">
<div className="col-sm-12 col-md-7 calculatorStyle">
    <Formik
      initialValues={initialCylinderValues}
      validationSchema={cylinderSchema}
      onSubmit={onSubmitCylinder}
    >
      {(formik) => (
        <Form>
          <div className="mb-3">
            <h3
              className="p-3 mb-2 bg-success text-white"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              Cylinder Volume Calculation - Cylinder Volume Calculator
            </h3>
            <TextField
              label="Base Radius"
              name="baseRadius"
              value={formik.values.baseRadius}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.baseRadius && formik.errors.baseRadius
              }
              helperText={
                formik.touched.baseRadius && formik.errors.baseRadius
              }
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="baseRadiusUnit"
              value={formik.values.baseRadiusUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <TextField
              label="Height"
              name="height"
              value={formik.values.height}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.height && formik.errors.height}
              helperText={
                formik.touched.height && formik.errors.height
              }
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="heightUnit"
              value={formik.values.heightUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <Button
              type="submit"
              disabled={!formik.isValid}
              color="success"
              sx={{
                backgroundColor: "rgb(25,135,84)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
            >
              Calculate
            </Button>
            <Button
              disabled={!formik.isValid}
              sx={{
                backgroundColor: "rgb(108,117,125)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
              onClick={() => {
                setCylinderVolume(null);
                formik.resetForm();
              }}
            >
              Clear Result
            </Button>
          </div>
          {cylinderVolume && cylinderVolume > 0 ? (
            <Fragment>
              <p className="p-3 mb-2 bg-success text-white">
                Result: Cylinder volume is: {cylinderVolume}{" "}
                {convertedCylinderUnit}
                <sup>3</sup>
              </p>
            </Fragment>
          ) : (
            ""
          )}
        </Form>
      )}
    </Formik>
  </div>
  <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
    <img alt="Cylinder Volume Calculator" src={cylinderimg} />
  </div>
</div>
          <hr />
                    <div className="row">
<div className="col-sm-12 col-md-7 calculatorStyle">
    <Formik
      initialValues={initialRectangularValues}
      validationSchema={rectangularSchema}
      onSubmit={onSubmitRectangular}
    >
      {(formik) => (
        <Form>
          <div className="mb-3">
            <h3
              className="p-3 mb-2 bg-success text-white"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              Rectangular Tank Volume Calculation - Rectangular Tank Volume Calculator
            </h3>
            <TextField
              label="Length"
              name="length"
              value={formik.values.length}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.length && formik.errors.length}
              helperText={formik.touched.length && formik.errors.length}
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="lengthUnit"
              value={formik.values.lengthUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <TextField
              label="Width"
              name="width"
              value={formik.values.width}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.width && formik.errors.width}
              helperText={formik.touched.width && formik.errors.width}
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="widthUnit"
              value={formik.values.widthUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <TextField
              label="Height"
              name="height"
              value={formik.values.height}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.height && formik.errors.height}
              helperText={formik.touched.height && formik.errors.height}
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="heightUnit"
              value={formik.values.heightUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <Button
              type="submit"
              disabled={!formik.isValid}
              color="success"
              sx={{
                backgroundColor: "rgb(25,135,84)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
            >
              Calculate
            </Button>
            <Button
              disabled={!formik.isValid}
              sx={{
                backgroundColor: "rgb(108,117,125)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
              onClick={() => {
                setRectangularVolume(null);
                formik.resetForm();
              }}
            >
              Clear Result
            </Button>
          </div>
          {rectangularVolume && rectangularVolume > 0 ? (
            <Fragment>
              <p className="p-3 mb-2 bg-success text-white">
                Result: Rectangular tank volume is: {rectangularVolume}{" "}
                {convertedRectangularUnit}
                <sup>3</sup>
              </p>
            </Fragment>
          ) : (
            ""
          )}
        </Form>
      )}
    </Formik>
  </div>
  <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
    <img alt="Rectangular Tank Volume Calculator" src={rectangularimg} />
  </div>
</div>
          <hr />
                    <div className="row">
  <div className="col-sm-12 col-md-7 calculatorStyle">
    <Formik
      initialValues={initialCapsuleValues}
      validationSchema={capsuleSchema}
      onSubmit={onSubmitCapsule}
    >
      {(formik) => (
        <Form>
          <div className="mb-3">
            <h3
              className="p-3 mb-2 bg-success text-white"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              Calculate Capsule Volume - Capsule Volume Calculator
            </h3>
            <TextField
              label="Base Radius"
              name="baseRadius"
              value={formik.values.baseRadius}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.baseRadius && formik.errors.baseRadius}
              helperText={
                formik.touched.baseRadius && formik.errors.baseRadius
              }
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="baseRadiusUnit"
              value={formik.values.baseRadiusUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <TextField
              label="Height"
              name="height"
              value={formik.values.height}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.height && formik.errors.height}
              helperText={formik.touched.height && formik.errors.height}
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="heightUnit"
              value={formik.values.heightUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <Button
              type="submit"
              disabled={!formik.isValid}
              color="success"
              sx={{
                backgroundColor: "rgb(25,135,84)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
            >
              Calculate
            </Button>
            <Button
              disabled={!formik.isValid}
              sx={{
                backgroundColor: "rgb(108,117,125)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
              onClick={() => {
                setCapsuleVolume(null);
                formik.resetForm();
              }}
            >
              Clear Result
            </Button>
          </div>
          {capsuleVolume && capsuleVolume > 0 ? (
            <Fragment>
              <p className="p-3 mb-2 bg-success text-white">
                Result: Capsule volume is {capsuleVolume} {convertedCapsuleUnit}
                <sup>3</sup>
              </p>
            </Fragment>
          ) : (
            ""
          )}
        </Form>
      )}
    </Formik>
  </div>
  <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
    <img alt="Capsule Volume Calculation" src={capsuleimg} />
  </div>
</div>
<hr />
<div className="row">
<div className="col-sm-12 col-md-7 calculatorStyle">
    <Formik
      initialValues={initialConicalValues}
      validationSchema={conicalSchema}
      onSubmit={onSubmitConical}
    >
      {(formik) => (
        <Form>
          <div className="mb-3">
            <h3
              className="p-3 mb-2 bg-success text-white"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              Calculate Conical Frustum Volume - Conical Frustum Volume Calculator
            </h3>
            <TextField
              label="Top Radius"
              name="topRadius"
              value={formik.values.topRadius}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.topRadius && formik.errors.topRadius}
              helperText={formik.touched.topRadius && formik.errors.topRadius}
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="topRadiusUnit"
              value={formik.values.topRadiusUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <TextField
              label="Bottom Radius"
              name="bottomRadius"
              value={formik.values.bottomRadius}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.bottomRadius && formik.errors.bottomRadius}
              helperText={
                formik.touched.bottomRadius && formik.errors.bottomRadius
              }
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="bottomRadiusUnit"
              value={formik.values.bottomRadiusUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <TextField
              label="Height"
              name="height"
              value={formik.values.height}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.height && formik.errors.height}
              helperText={formik.touched.height && formik.errors.height}
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="heightUnit"
              value={formik.values.heightUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <Button
              type="submit"
              disabled={!formik.isValid}
              color="success"
              sx={{
                backgroundColor: "rgb(25,135,84)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
            >
              Calculate
            </Button>
            <Button
              disabled={!formik.isValid}
              sx={{
                backgroundColor: "rgb(108,117,125)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
              onClick={() => {
                setConicalVolume(null);
                formik.resetForm();
              }}
            >
              Clear Result
            </Button>
          </div>
          {conicalVolume && conicalVolume > 0 ? (
            <Fragment>
              <p className="p-3 mb-2 bg-success text-white">
                Result: Conical frustum volume is {conicalVolume}{" "}
                {convertedConicalUnit}
                <sup>3</sup>
              </p>
            </Fragment>
          ) : (
            ""
          )}
        </Form>
      )}
    </Formik>
  </div>
  <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
    <img alt="Conical Frustum Volume Calculation" src={conicalimg} />
  </div>
</div>
          <hr />
                    <div className="row">
<div className="col-sm-12 col-md-7 calculatorStyle">
    <Formik
      initialValues={initialEllipsoidValues}
      validationSchema={ellipsoidSchema}
      onSubmit={onSubmitEllipsoid}
    >
      {(formik) => (
        <Form>
          <div className="mb-3">
            <h3
              className="p-3 mb-2 bg-success text-white"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              Calculate Ellipsoid Volume - Ellipsoid Volume Calculator
            </h3>
            <TextField
              label="Axis1"
              name="axis1"
              value={formik.values.axis1}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.axis1 && formik.errors.axis1}
              helperText={formik.touched.axis1 && formik.errors.axis1}
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="axis1Unit"
              value={formik.values.axis1Unit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <TextField
              label="Axis2"
              name="axis2"
              value={formik.values.axis2}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.axis2 && formik.errors.axis2}
              helperText={formik.touched.axis2 && formik.errors.axis2}
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="axis2Unit"
              value={formik.values.axis2Unit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <TextField
              label="Axis3"
              name="axis3"
              value={formik.values.axis3}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.axis3 && formik.errors.axis3}
              helperText={formik.touched.axis3 && formik.errors.axis3}
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="axis3Unit"
              value={formik.values.axis3Unit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <Button
              type="submit"
              disabled={!formik.isValid}
              color="success"
              sx={{
                backgroundColor: "rgb(25,135,84)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
            >
              Calculate
            </Button>
            <Button
              disabled={!formik.isValid}
              sx={{
                backgroundColor: "rgb(108,117,125)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
              onClick={() => {
                setEllipsoidVolume(null);
                formik.resetForm();
              }}
            >
              Clear Result
            </Button>
          </div>
          {ellipsoidVolume && ellipsoidVolume > 0 ? (
            <Fragment>
              <p className="p-3 mb-2 bg-success text-white">
                Result: Ellipsoid volume is {ellipsoidVolume}{" "}
                {convertedEllipsoidUnit}
                <sup>3</sup>
              </p>
            </Fragment>
          ) : (
            ""
          )}
        </Form>
      )}
    </Formik>
  </div>
  <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
    <img alt="Calculate Ellipsoid Volume" src={ellipsoidimg} />
  </div>
</div>
<hr />
<div className="row">
<div className="col-sm-12 col-md-7 calculatorStyle">
    <Formik
      initialValues={initialPyramidValues}
      validationSchema={pyramidSchema}
      onSubmit={onSubmitPyramid}
    >
      {(formik) => (
        <Form>
          <div className="mb-3">
            <h3
              className="p-3 mb-2 bg-success text-white"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              Pyramid Volume Calculator
            </h3>
            <TextField
              label="Base Edge"
              name="baseEdge"
              value={formik.values.baseEdge}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.baseEdge && formik.errors.baseEdge}
              helperText={formik.touched.baseEdge && formik.errors.baseEdge}
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="baseEdgeUnit"
              value={formik.values.baseEdgeUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <TextField
              label="Height"
              name="height"
              value={formik.values.height}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.height && formik.errors.height}
              helperText={formik.touched.height && formik.errors.height}
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="heightUnit"
              value={formik.values.heightUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <Button
              type="submit"
              disabled={!formik.isValid}
              color="success"
              sx={{
                backgroundColor: "rgb(25,135,84)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
            >
              Calculate
            </Button>
            <Button
              disabled={!formik.isValid}
              sx={{
                backgroundColor: "rgb(108,117,125)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
              onClick={() => {
                setPyramidVolume(null);
                formik.resetForm();
              }}
            >
              Clear Result
            </Button>
          </div>
          {pyramidVolume && pyramidVolume > 0 ? (
            <Fragment>
              <p className="p-3 mb-2 bg-success text-white">
                Result: Pyramid volume is {pyramidVolume}{" "}
                {convertedPyramidUnit}
                <sup>3</sup>
              </p>
            </Fragment>
          ) : (
            ""
          )}
        </Form>
      )}
    </Formik>
  </div>
  <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
    <img alt="Calculate Pyramid Volume" src={pyramidimg} />
  </div>
</div>
  <hr />
                    <div className="row">
<div className="col-sm-12 col-md-7 calculatorStyle">
    <Formik
      initialValues={initialTubeValues}
      validationSchema={tubeSchema}
      onSubmit={onSubmitTube}
    >
      {(formik) => (
        <Form>
          <div className="mb-3">
            <h3
              className="p-3 mb-2 bg-success text-white"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              Tube Volume Calculator - Tube Volume Calculator
            </h3>
            <TextField
              label="Outer Diameter"
              name="outerDiameter"
              value={formik.values.outerDiameter}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.outerDiameter &&
                formik.errors.outerDiameter
              }
              helperText={
                formik.touched.outerDiameter &&
                formik.errors.outerDiameter
              }
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="outerDiameterUnit"
              value={formik.values.outerDiameterUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <TextField
              label="Inner Diameter"
              name="innerDiameter"
              value={formik.values.innerDiameter}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.innerDiameter &&
                formik.errors.innerDiameter
              }
              helperText={
                formik.touched.innerDiameter &&
                formik.errors.innerDiameter
              }
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="innerDiameterUnit"
              value={formik.values.innerDiameterUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <TextField
              label="Length"
              name="length"
              value={formik.values.length}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.length && formik.errors.length}
              helperText={
                formik.touched.length && formik.errors.length
              }
              sx={{
                width: "160px",
                ml: "10px",
                bgcolor: "#f9f9f9",
                "&  .MuiFormHelperText-root.Mui-error": {
                  backgroundColor: "rgb(229, 230, 227) !important",
                  margin: 0,
                  padding: "8px 0 0 41px",
                },
              }}
              size="small"
              color="success"
            />
            <Field
              as={TextField}
              select
              name="lengthUnit"
              value={formik.values.lengthUnit}
              onChange={formik.handleChange}
              size="small"
              style={{
                backgroundColor: "#f9f9f9",
                pending: "5px",
              }}
            >
              {Object.keys(conversionMap).map((unit) => (
                <MenuItem key={unit} value={unit}>
                  {unit}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="mb-3">
            <Button
              type="submit"
              disabled={!formik.isValid}
              color="success"
              sx={{
                backgroundColor: "rgb(25,135,84)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
            >
              Calculate
            </Button>
            <Button
              disabled={!formik.isValid}
              sx={{
                backgroundColor: "rgb(108,117,125)",
                fontSize: "15px",
                marginRight: "25px",
                padding: "5px 25px",
                color: "white",
              }}
              onClick={() => {
                setTubeVolume(null);
                formik.resetForm();
                setErrorDiameter("");
              }}
            >
              Clear Result
            </Button>
          </div>
          {errorDiameter && (
            <p className="p-3 mb-2 bg-danger text-white">
              {errorDiameter}
            </p>
          )}
          {tubeVolume && tubeVolume > 0 ? (
            <Fragment>
              <p className="p-3 mb-2 bg-success text-white">
                Result: Tube volume is {tubeVolume}{" "}
                {convertedTubeUnit}
                <sup>3</sup>
              </p>
            </Fragment>
          ) : (
            ""
          )}
        </Form>
      )}
    </Formik>
  </div>
  <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
    <img alt="Tube Volume Calculator" src={tubeimg} />
  </div>
</div>
          <hr />
          <div className="row">
            <RelatedLinks />
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList
            CalculatorsTypeId={CalculatorsType.mathCalculators}
          ></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }} >
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
          <div className="info-section">
  <div className="info-section-header">
    <u><h2 style={{ fontSize: '16px' }}>Geometric and Mathematical Shapes Volume</h2></u>
  </div>
  <div className="info-section-body">
    <p>
      Volume is an estimation of the three-dimensional space occupied by a physical object. The international unit for volume is the cubic meter, or m3. Traditionally, it is preferred that the volume of a container is usually its capacity and the amount of liquid it can hold, rather than the actual space it occupies. Volumes of many shapes can be calculated using well-known formulas. In some cases, more complex shapes can be broken down into simpler composite shapes, and their volumes are summed up to determine the total volume. Volumes of other more complex shapes can be calculated using differential and integral calculus if there is a known formula for the boundaries of the shape. Additionally, volumes of shapes that cannot be described by known equations can be estimated using mathematical methods such as the finite element method. Alternatively, if the density of a substance is known and homogeneous, the volume can be calculated using its weight. This calculator calculates volumes for some of the most common simple shapes.
    </p>
    <br />
  </div>
</div>
<div className="info-section">
  <div className="info-section-header">
    <u><h3 style={{ fontSize: '16px' }}>Sphere Volume Calculation - Sphere Volume Calculator</h3></u>
  </div>
  <div className="info-section-body">
    <p>
      A sphere is a three-dimensional geometric object resembling a two-dimensional circle. It is a perfectly round geometric structure, mathematically defined as a set of points equidistant from a central point, where the radius (r) is the distance from the central point to any point on the sphere. Although a sphere includes the common understanding of a spherical object, it accurately represents the geometric shape.
    </p>
    <p>
      Similar to a circle, the diameter (d) refers to the line connecting two points on the sphere through its center, the longest line. The volume of the sphere can be calculated using the following equation:
    </p>
    <p>
      Volume = 4/3 × π × r³
    </p>
    <p>
      Example: Dina wants to fill a perfectly spherical water balloon with a radius of 0.15 feet with olive oil and use it in a water balloon fight against her close friend Samia this weekend. The required volume of olive oil can be calculated using the provided equation:
    </p>
    <p>
      Volume = 4/3 × π × (0.15)³ = 0.141 cubic feet
    </p>
    <br />
  </div>
</div>
<div className="info-section">
  <div className="info-section-header">
    <u><h3 style={{ fontSize: '16px' }}>Cone Volume Calculation - Cone Volume Calculator</h3></u>
  </div>
  <div className="info-section-body">
    <p>
      A cone is a three-dimensional shape smoothly tapering from its circular base to a common point called the apex (or vertex). Mathematically, the cone is formed similarly to the circle, by a set of connected lines converging at a common point, except that the center point is not included in the plane containing the circle (or another base). Here, only the right circular cone is considered, and not cones composed of half-lines, non-circular bases, etc., extending indefinitely. The equation for calculating the volume of the cone is as follows:
    </p>
    <p>
      Volume = 1/3 × π × r² × h
    </p>
    <p>
      Where r is the radius of the base and h is the height of the cone.
    </p>
    <p>
      Example: Lena is determined to get an ice cream cone for $5 she rightfully earned. Despite her preference for regular cones, the delicious waffle cones are undoubtedly much larger. She decides she has a 15% preference for delicious waffle cones over regular cones and needs to calculate if the volume of the waffle cone exceeds 15% of the regular cone's volume. The volume of the delicious waffle cone with a circular base, a radius of 1.5 inches, and a height of 5 inches can be calculated using the equation below:
    </p>
    <p>
      Volume = 1/3 × π × 1.5² × 5 = 11.781 cubic inches
    </p>
    <p>
      Lena also calculates the volume of the regular cone and finds the difference to be less than 15%, deciding to purchase the regular cone. Now all she has to do is use her charm and appeal to convince the staff to fill her cone with ice cream.
    </p>
    <br />
  </div>
</div>
<div className="info-section">
  <div className="info-section-header">
    <u><h3 style={{ fontSize: '16px' }}>Cube Volume Calculation - Cube Volume Calculator</h3></u>
  </div>
  <div className="info-section-body">
    <p>
      A cube is the three-dimensional counterpart of the square, a solid bounded by six square faces, where three meet at each corner, and all are perpendicular to their adjacent faces. The cube is considered a special case in many shape classifications in geometry, including being a parallelepiped, an equilateral cuboid, and a right rhombohedron. Here is the equation for calculating the volume of the cube:
    </p>
    <p>
      Volume = a³
    </p>
    <p>
      Where a is the length of the cube's edge.
    </p>
    <p>
      Example: Leila, born in Alaska (dreaming of seeing the sun once), decided to visit her homeland in Hawaii. Enchanted by the beauty of Hawaiian nature, Leila decided to bring a piece of that beauty back home. Leila carries a cubic suitcase with edges of length 3 feet and calculates the volume of the soil she can bring with her using the following method:
    </p>
    <p>
      Volume = 3³ = 27 cubic feet
    </p>
    <br />
  </div>
</div>
<div className="info-section">
    <div className="info-section-header">
        <u><h3 style={{ fontSize: '16px' }}> Calculate Cylinder Volume - Cylinder Volume Calculator </h3></u>
    </div>
    <div className="info-section-body">
        <p>
            The cylinder, in its simplest design, is defined as a surface composed of points at a fixed distance from a certain axis. In its common usage, the term "cylinder" usually refers to a right circular cylinder, where its bases are connected circles across their centers by an axis perpendicular to their surfaces, with a certain height (h) and a radius (r). The equation for calculating the volume of the cylinder is shown below:
        </p>
        <p>
            Volume = πr²h
        </p>
        <p>
            Where r is the radius, and h is the height of the cylinder.
        </p>
        <p>
            Example: Zakaria wants to build a sandcastle in his living room. As a strong advocate for the environment, he retrieved three cylindrical barrels from an illegal dumping site and cleaned them from chemicals using dish soap and water. These barrels have a radius of 3 feet and a height of 4 feet. Zakaria calculates the volume of sand they can hold using the equation below:
        </p>
        <p>
            Volume = π × 3² × 4 = 113.097 cubic feet
        </p>
        <p>
            He successfully built a fantastic sandcastle at home, and as an additional bonus, he managed to save electricity by illuminating the sandcastle at night, glowing with a light green color in the dark.
        </p>
        <br />
    </div>
</div>
<div className="info-section">
    <div className="info-section-header">
        <u><h3 style={{ fontSize: '16px' }}> Calculate Rectangular Tank Volume - Rectangular Tank Volume Calculator </h3></u>
    </div>
    <div className="info-section-body">
        <p>
            The rectangular tank is a general formation of a cube, where the sides can have varying lengths. It is bounded by six faces, with three meeting at its corners, all perpendicular to their adjacent faces. The equation for calculating the volume of the rectangular tank is shown below:
        </p>
        <p>
            Volume = Length × Width × Height
        </p>
        <p>
            Example: Leila loves cake. She visits the gym for 4 hours every day to compensate for her love of cake. She plans a hiking trip to Mount Kalalau in Kauai, and although she is in excellent physical condition, Leila is worried about the absence of cake. She decides to pack only the essentials and wants to fill her rectangular bag with lengths, widths, and heights of 4 feet, 3 feet, and 2 feet, respectively, with cake. The precise volume calculation for the cake she can fit into her bag is as follows:
        </p>
        <p>
            Volume = 2 × 3 × 4 = 24 cubic feet
        </p>
        <br />
    </div>
</div>
<div className="info-section">
    <div className="info-section-header">
        <u><h3 style={{ fontSize: '16px' }}> Calculate Capsule Volume - Capsule Volume Calculator </h3></u>
    </div>
    <div className="info-section-body">
        <p>
            The capsule is a three-dimensional geometric shape consisting of a cylinder and two hemispherical ends, where the hemisphere is considered half of a sphere. As a result, the volume of the capsule can be calculated by combining the volume equations of the sphere and the right circular cylinder:
        </p>
        <p>
            Volume = πr²h + (4/3)πr³ = πr²(4/3r + h)
        </p>
        <p>
            Where r is the radius, and h is the height of the cylindrical part.
        </p>
        <p>
            Example: Based on a capsule with a radius of 1.5 feet and a height of 3 feet, determine the volume of melted chocolate cubes that Joe can carry in the time capsule he plans to bury for future generations on his journey to self-discovery through the Himalayas:
        </p>
        <p>
            Volume = π × 1.5² × 3 + (4/3)π × 1.5³ = 35.343 cubic feet
        </p>
        <br />
    </div>
</div>
<div className="info-section">
    <div className="info-section-header">
        <u><h3 style={{ fontSize: '16px' }}> Calculate Conical Frustum Volume - Conical Frustum Volume Calculator </h3></u>
    </div>
    <div className="info-section-body">
        <p>
            The frustum is the part of a solid body that remains when a cone is cut by parallel surfaces. This calculator calculates the volume of the right conical frustum specifically. Examples of conical frustums in everyday life include lampshades, water containers, and some drinking cups.
        </p>
        <p>
            The volume of the right conical frustum is calculated using the following equation:
        </p>
        <p>
            <strong>Volume = (1/3) × πh(r<sup>2</sup> + rR + R<sup>2</sup>)</strong>
        </p>
        <p>
            Where r and R are the radii of the frustum bases, and h is the height of the frustum.
        </p>
        <h4>Example:</h4>
        <p>
            Dreams successfully acquired some ice cream in sugar cones and consumed it in a way that leaves the ice cream compressed inside the cone. Her brother decides to grab the cone and take a bite from the bottom of the cone, which is parallel to the previous opening. Dreams now holds a right conical frustum leaking ice cream, and she needs to calculate the volume of the ice cream she must quickly consume due to an elevation of 4 inches, with the bottom radius of 1.8 inches and the top radius of 0.3 inches.
        </p>
        <p>
            <strong>Volume = (1/3) × π × 4(0.3<sup>2</sup> + 0.3 × 1.8 + 1.8<sup>2</sup>) = 12.547 cubic inches</strong>
        </p>
        <br />
    </div>
</div>
<div className="info-section">
    <div className="info-section-header">
        <u><h3 style={{ fontSize: '16px' }}> Calculate Ellipsoid Volume - Ellipsoid Volume Calculator </h3></u>
    </div>
    <div className="info-section-body">
        <p>
            The ellipsoid is a three-dimensional shape that arises from the distortion of a sphere due to changes in the scale of its directional elements. The center of the ellipsoid is defined at the intersection point of three orthogonal symmetry axes, and the lines that define these axes are called the principal axes. If it has a different length for each of the three, the ellipsoid shape is usually described as triaxial. The equation for calculating the volume of the ellipsoid is as follows:
        </p>
        <p>
            <strong>Volume = (4/3) × πabc</strong>
        </p>
        <p>
            Where a, b, and c are the lengths of the axes.
        </p>
        <h4>Example:</h4>
        <p>
            Leila only loves eating sweets, but her mother wants to monitor the amount of candy she consumes. Her mother allows her to eat candy that fits into an ellipsoidal cake. Leila carves the cake to achieve the maximum volume of candy she can fit into the carved cake. After finding that the cake has axis lengths of 2.5 inches, 3 inches, and 6 inches, Leila calculates the volume of candy she can fit into the sculpted cake as follows:
        </p>
        <p>
            <strong>Volume = (4/3) × π × 2.5 × 3 × 6 = 94.247 cubic inches</strong>
        </p>
        <br />
    </div>
</div>
<div className="info-section">
    <div className="info-section-header">
        <u><h3 style={{ fontSize: '16px' }}> Calculate Pyramid Volume - Pyramid Volume Calculator </h3></u>
    </div>
    <div className="info-section-body">
        <p>
            In mathematical geometry, a pyramid is a three-dimensional shape formed by connecting a polygonal base to a point known as its apex. The polygonal shape is a flat shape defined by a number of straight lines. There can be different shapes for the base of the pyramid, and a square pyramid has a square base. The position of the apex distinguishes different types of pyramids, where a right pyramid has its apex directly above the center of its base. The volume of a pyramid, regardless of the apex position, can be calculated using the following formula:
        </p>
        <p>
            <strong>General Pyramid Volume:</strong>
        </p>
        <p>
            <strong>Volume = (1/3) × base area × height</strong>
        </p>
        <p>
            Where the base area is denoted by 'b' and the height is denoted by 'h'.
        </p>
        <p>
            <strong>Square Pyramid Volume:</strong>
        </p>
        <p>
            <strong>Volume = (1/3) × base edge length² × height</strong>
        </p>
        <p>
            Where the edge length is denoted by 'a'.
        </p>
        <h4>Example:</h4>
        <p>
            Adam has a special admiration for ancient civilizations and structures like pyramids. Being the eldest among his siblings one, two, and three, he can easily direct them. Taking advantage of this, Adam decides to revive ancient times and makes his siblings pretend to be workers building a clay pyramid with a base length of 5 feet and a height of 12 feet. The volume of this pyramid can be calculated using the formula for a square pyramid:
        </p>
        <p>
            <strong>Volume = (1/3) × 5² × 12 = 100 cubic feet</strong>
        </p>
        <br />
    </div>
</div>
<div className="info-section">
    <div className="info-section-header">
        <u><h3 style={{ fontSize: '16px' }}> Calculate Tube Volume - Tube Volume Calculator </h3></u>
    </div>
    <div className="info-section-body">
        <p>
            A tube, often referred to as a pipe, is a hollow cylinder commonly used for transporting liquids or gases. Calculating the volume of the tube essentially involves using the same formula as for calculating the volume of a cylinder (Volume = πr²h), except in this case, the diameter is used instead of the radius, and the length is used instead of the height. So, the formula involves measuring the internal and external diameters of the cylinder, calculating the volume of each, and subtracting the volume of the internal cylinder from the external one. Based on the mentioned length and diameters, the formula for calculating the tube volume is as follows:
        </p>
        <p>
            <strong>Volume = π × (d₁² - d₂²) / 4 × l</strong>
        </p>
        <p>
            Where d₁ is the external diameter, d₂ is the internal diameter, and l is the length of the tube.
        </p>
        <h4>Example:</h4>
        <p>
            Nada is committed to maintaining the environment, using eco-friendly materials in her construction company. A customer has a vacation home in the forest and wants to build a path across a water table without impacting his favorite fishing spot. Nada plans to build a tube across the table to bypass the dams created by beavers. The required low-impact concrete volume for building a tube with an external diameter of 3 feet, internal diameter of 2.5 feet, and length of 10 feet can be calculated as follows:
        </p>
        <p>
            <strong>Volume = π × (3² - 2.5²) / 4 × 10 = 21.6 cubic feet</strong>
        </p>
        <br />
    </div>
</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default VolumesCalculator;
